import { useEffect } from "react";
import { useTransitionState } from "react-transition-state";

/**
 * Modal component.
 */
const Modal = ({
    open,
    title,
    description,
    children,
    onClose,
    size = "md",
    handle,
    extraClasses = {},
    disableClose = false,
}) => {
    const [{ status, isMounted }, toggle] = useTransitionState({
        timeout: 250,
        mountOnEnter: true,
        unmountOnExit: true,
        preEnter: true,
    });

    useEffect(() => {
        toggle(!!open);
    }, [open, toggle]);

    const mapStatusClasses = (s) => {
        // keep raw status and add legacy classes but keep them separated so enter animation can play:
        // preEnter -> preEnter (start state)
        // entering -> enter (triggers transition)
        // entered -> enter-done (final)
        // preExit/exiting -> exit (start of exit)
        // exited -> exit-done (hidden)
        if (!s) return "";
        const classes = [s];
        if (s === "preEnter") classes.push("preEnter");
        if (s === "entering") classes.push("enter");
        if (s === "entered") classes.push("enter-done");
        if (s === "preExit" || s === "exiting") classes.push("exit");
        if (s === "exited") classes.push("exit-done");
        return classes.join(" ").trim();
    };

    const closeAction = () => {
        if (!disableClose) toggle(false);
        handle && handle(false);
        onClose && onClose();
    };

    if (!isMounted) return null;

    return (
        <div
            className={`modal ${extraClasses?.modal || ""} ${mapStatusClasses(status)}`}
        >
            <div
                className={`modal__content modal__content--${size} ${extraClasses?.content || ""}`}
            >
                {!disableClose && (
                    <button
                        type="button"
                        className="modal__close"
                        onClick={closeAction}
                    >
                        <span className="sr-only">Fermer la modale</span>
                        <i className="vnf-icons-icon-m-croix-fermer-outline"></i>
                    </button>
                )}

                <div className="modal__header">
                    {title && <h2 className="modal__title">{title}</h2>}
                    {description && (
                        <p
                            className={`modal__description ${extraClasses?.description || ""}`}
                        >
                            {description}
                        </p>
                    )}
                </div>

                <div className={`modal__body ${extraClasses?.body || ""}`}>
                    {children}
                </div>
            </div>

            <div className="modal__overlay" onClick={closeAction} />
        </div>
    );
};

export default Modal;
